import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { RescheduleSlotButton } from './reschedule-slot-button.component';

import type { AvailableDay } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/variants/_components/appointment-options/_components/reschedule-slots-modal/_hooks/use-reschedule-slots.hook';
import type { RescheduleAvailableHour } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/variants/_components/appointment-options/_services/get-appointment-avaiable-hours.service';

interface RescheduleDayColumnProps {
  day: AvailableDay;
  isReschedulingSlotId: string | null;
  onSlotClick: (slot: RescheduleAvailableHour) => void;
}

export function RescheduleDayColumn({ day, isReschedulingSlotId, onSlotClick }: RescheduleDayColumnProps) {
  const isAnySlotPending = isReschedulingSlotId !== null;

  return (
    <div
      className="flex flex-1 flex-col items-center gap-2"
      data-testid={`${DataTestIdEnum.APPOINTMENT_RESCHEDULE_DAY_COLUMN}-${day.date}`}
    >
      <div className="flex flex-col items-center text-center text-gray-700">
        <p className="text-sm font-semibold leading-5">{day.weekday}</p>
        <p className="text-base font-normal leading-6">{day.dayMonth}</p>
      </div>
      {day.slots.map((slot) => (
        <RescheduleSlotButton
          key={slot.id}
          slot={slot}
          isLoading={isReschedulingSlotId === slot.id}
          isDisabled={isAnySlotPending && isReschedulingSlotId !== slot.id}
          onClick={() => onSlotClick(slot)}
        />
      ))}
    </div>
  );
}
